export default __webpack_public_path__ + "static/media/greenSmallTick.b769a5c1.svg";